import {
  checkFutureDate,
  checkValidDate,
  isValidAddress,
  isValidDate,
  isValidName,
  isValidZipCode,
} from '@brands/Utils/validation';
import parsePhoneNumberFromString from 'libphonenumber-js';
import * as Yup from 'yup';

export const profileValidationSchema = (): any => {
  return Yup.object().shape({
    first_name: Yup.string()
      .required('First name is required')
      .test('test-name', 'Enter Valid First Name', (value) => {
        if (value && !isValidName(value)) {
          return false;
        }
        return true;
      }),
    middle_name: Yup.string().test('test-name', 'Enter Valid Middle Name', (value) => {
      if (value && !isValidName(value)) {
        return false;
      }
      return true;
    }),
    last_name: Yup.string()
      .required('Last name is required')
      .test('test-name', 'Enter Valid Last Name', (value) => {
        if (value && !isValidName(value)) {
          return false;
        }
        return true;
      }),
    gender: Yup.string()
      .required('Gender is required')
      .test('test-name', 'Gender is required', (value) => {
        if (value === '') {
          return false;
        }
        return true;
      }),
    gender_identity: Yup.string()
      .required('Gender identity is required')
      .test('test-name', 'Gender identity is required', (value) => {
        if (value === '') {
          return false;
        }
        return true;
      }),
    date_of_birth: Yup.string()
      .required('Date of birth is required')
      .test('test-name', 'Valid date: MM/DD/YYYY', (value) => {
        if (value && !isValidDate(value)) {
          return false;
        }
        if (value) {
          const values = value?.split('/');
          if (!checkValidDate(values[0], values[1], values[2])) {
            return false;
          }
        }
        return true;
      })
      .test('test-future', `DOB can't be in the future`, (value) => {
        if (value) {
          const values = value?.split('/');
          if (!checkFutureDate(values[0], values[1], values[2])) {
            return false;
          }
        }
        return true;
      }),
    phone_number: Yup.string()
      .required('Phone number is required')
      .test('test-name', 'Enter Valid Phone Number', (value) => {
        if (!value) return false; // Ensure value exists

        const phoneNumber = parsePhoneNumberFromString(value, 'US'); // Parse the number
        return phoneNumber?.isValid() ?? false; // Validate it
      }),
    language: Yup.array().nullable().min(1, 'Language is required').required('Language is required'),
    address1: Yup.string()
      .required('Address is required')
      .test('test-name', 'Enter Valid Address', (value) => {
        if (value && !isValidAddress(value)) {
          return false;
        }
        return true;
      }),
    address2: Yup.string(),
    city: Yup.string().required('City is required'),
    state: Yup.string().required('State is required'),
    zip_code: Yup.string()
      .required('Zip Code is required')
      .test('test-name', 'Enter Valid Zip Code', (value) => {
        if (value && !isValidZipCode(value)) {
          return false;
        }
        return true;
      }),
  });
};
